export const APP_VERSION = '1.0.0.1793537507034';
